import { Component } from '@angular/core';
import { saveAs } from 'file-saver';

@Component({
  selector: 'sihach-table',
  templateUrl: './sihach-table.component.html',
  styleUrls: ['./sihach-table.component.css'],
})
export class SihachTableComponent {
  tableData;
  sihachData;
  sihachItemOver;
  lastClickedWord: any;
  currentItemType: any;
  currentItem: any;
  lastTarget: any;
  origSihachData: any;
  popupPositionLeft: number = 0;
  popupPositionTop: number = 0;
  uid: string = '';
  lineTableData: any;
  lineTableHeaders: any;

  ngAfterViewInit() {}

  printScore(item) {
    const conf = Math.round(item.value.word.confidence * 100);
    const score = Math.round(item.value.score * 100);
    return score;
  }
  displayTable(body: any) {
    this.sihachData = body;
    this.uid = body.uid;

    this.tableData = [];
    for (let key in this.sihachData['data']) {
      let value = this.sihachData['data'][key];
      let item = {
        key,
        label: { word: { text: key } },
        value: value ?? { word: { text: '' } },
        chosen: false,
      };
      // console.log(item)
      // if (this.printScore(item)) {
      this.tableData.push(item);
      // }
    }
    this.lineTableData = [];
    this.lineTableHeaders = [];
    const lines = this.sihachData['lines'];
    if (lines != null) {
      for (let line of lines) {
        let lineData: any = [];
        this.lineTableData.push(lineData);
        for (let key in line['data']) {
          let value = line['data'][key];
          lineData.push(value);
        }
      }
      if (lines.length > 0) {
        let line = this.sihachData['lines'][0];
        for (let key in line['data']) {
          this.lineTableHeaders.push(key);
        }
        console.log(this.lineTableHeaders);
      }
      console.log(this.lineTableData);
    }
  }

  unchooseTr() {
    if (!this.tableData) return;
    for (let item of this.tableData) {
      item.chosen = false;
    }
  }

  itemFocusout() {}

  tableItemDown($event, type, item) {
    console.log($event);

    $event.currentTarget.style.backgroundColor = 'yellow';
    if (this.lastTarget && this.lastTarget != $event.currentTarget) {
      this.lastTarget.style.backgroundColor = 'white';
    }
    this.lastTarget = $event.currentTarget;
    this.currentItemType = item[type];
    this.currentItem = item;
  }

  wordClicked(word: any) {
    if (this.lastClickedWord == word) return;
    // console.log(word["description"]);
    this.lastClickedWord = word;
    setTimeout(() => {
      this.lastClickedWord = null;
    }, 1000);
    if (this.currentItemType) {
      this.currentItemType.word.text += ` ${word['description']}`;
    }
  }
  addRow() {
    this.tableData.unshift({
      label: { word: { text: '' } },
      value: { word: { text: '' } },
      chosen: true,
    });
  }
  restart() {
    this.unchooseTr();
    this.tableData = null;
    this.lineTableData = null;
    this.lineTableHeaders = [];
  }
  downloadImg() {
    const imgBase64 = `data:image/png;base64, ${this.sihachData.imgBase64}`;
    const link = document.createElement('a');
    link.href = imgBase64;
    link.download = 'sihach.png';
    link.click();
  }

  sihachLineOver(line_i: number) {
    this.sihachItemOver(this.sihachData['lines'][line_i]);
  }
}
